"use client"
import React from "react"
import { Link } from "react-router-dom"
import { ChevronRight, type LucideIcon } from "lucide-react"

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "components/ui/collapsible"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  useSidebar,
} from "components/ui/sidebar"

export function NavMain({
  items,
}: {
  items: {
    title: string
    url: string
    icon?: LucideIcon
    isActive?: boolean
    items?: {
      title: string
      url: string
    }[]
  }[]
}) {
  const { isMobile, setOpenMobile } = useSidebar()
  const [openItems, setOpenItems] = React.useState<Set<string>>(new Set())

  React.useEffect(() => {
    const saved = localStorage.getItem("sidebar-open-items")
    if (saved) {
      setOpenItems(new Set(JSON.parse(saved)))
    }
  }, [])

  const saveToLocalStorage = (newSet: Set<string>) => {
    localStorage.setItem("sidebar-open-items", JSON.stringify([...newSet]))
  }

  const toggleMenu = (title: string, state: boolean) => {
    const updated = new Set(openItems)
    if (state) {
      updated.add(title)
    } else {
      updated.delete(title)
    }
    setOpenItems(updated)
    saveToLocalStorage(updated)
  }

  const handleNavigation = () => {
    if (isMobile) {
      setOpenMobile(false)
    }
  }

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Finance</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => {
          const isOpen = openItems.has(item.title)
          return (
            <Collapsible
              key={item.title}
              asChild
              open={isOpen}
              onOpenChange={(state) => toggleMenu(item.title, state)}
              className="group/collapsible"
            >
              <SidebarMenuItem>
                <CollapsibleTrigger asChild>
                  <SidebarMenuButton tooltip={item.title}>
                    {item.icon && <item.icon />}
                    <span>{item.title}</span>
                    <ChevronRight className={`ml-auto transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`} />
                  </SidebarMenuButton>
                </CollapsibleTrigger>
                <CollapsibleContent>
                  <SidebarMenuSub>
                    {item.items?.map((subItem) => (
                      <SidebarMenuSubItem key={subItem.title}>
                        <SidebarMenuSubButton asChild>
                          <Link to={subItem.url} onClick={handleNavigation}>
                            <span>{subItem.title}</span>
                          </Link>
                        </SidebarMenuSubButton>
                      </SidebarMenuSubItem>
                    ))}
                  </SidebarMenuSub>
                </CollapsibleContent>
              </SidebarMenuItem>
            </Collapsible>
          )})}
      </SidebarMenu>
    </SidebarGroup>
  )
}
